import { type AuditLogChangedFieldApiModel } from '../api-models/AuditLogChangedFieldApiModel'

export const mapAuditLogChangedField = (
  change: AuditLogChangedFieldApiModel
) => ({
  field: change.field,
  from: change.from,
  to: change.to,
})
